// import kyc from './kyc/routes';
import resellerRoutes from './resellerForm/routes';
import createCompanyRoutes from './createCompany/routes';

export default [...resellerRoutes, ...createCompanyRoutes];
